<!--
  ⚠️ DESCONECTADO (ui-redesign). Mapa Leaflet retirado; se reconstruirá con
  MapLibre + clustering (docs/ui-redesign/05-map-redesign.md). Placeholder temporal.
-->
<div class="container-fluid" style="max-height: 450px">
	<div class="row">
		<div class="col-12 p-0">
			<div class="map-container">
				<div class="map-frame map-placeholder">
					<mat-icon>map</mat-icon>
					<span>{{ "map.redesign.placeholder" | translate }}</span>
				</div>
			</div>
		</div>
	</div>
</div>
